import { CONFIG } from '../config';

export const USER_API_URL = `${CONFIG.DISCOVERY_API_URL}/user-api`;
